import React from 'react';
import { funLinksData, knowledgeLinksData, dealsPillLinkData, lifestyleLinksData, dogVideosData, wagServicesData } from './data/urls';
import { DailyWagLogoSection } from './components/DailyWagLogoSection';
import { ChevronDownIconV2 } from '../../wag-react/next-components/icons';
import { factory } from '../../wag-react/components/site-navigation/utils/factory';
import { helper } from '../../wag-react/components/site-navigation/utils/helper';
import { NavigationDropdownList } from '../../wag-react/components/site-navigation/NavigationDropdownList/NavigationDropdownList';
import { SiteNavigation } from '../../wag-react/components/site-navigation/SiteNavigation/SiteNavigation';
import { SidebarLink } from '../../wag-react/components/site-navigation/SiteLeftSidebar/components/SidebarLink';
import { theme } from '../../wag-react/themes/base-theme';
const sidebarRoutes = [{
  header: <SidebarLink href={helper.attachQueryStringToRoute({
    url: dealsPillLinkData.url
  }).url}>
        {dealsPillLinkData.label}
      </SidebarLink>
}, {
  header: <SidebarLink>
        {funLinksData.label}
      </SidebarLink>,
  body: <>
        {funLinksData.subRoutes.map(({
      key,
      url,
      label
    }) => <SidebarLink key={key} href={helper.attachQueryStringToRoute({
      url
    }).url} ml="20px">
            {label}
          </SidebarLink>)}
      </>
}, {
  header: <SidebarLink>
        {knowledgeLinksData.label}
      </SidebarLink>,
  body: <>
        {knowledgeLinksData.subRoutes.map(({
      key,
      url,
      label
    }) => <SidebarLink key={key} href={helper.attachQueryStringToRoute({
      url
    }).url} ml="20px">
            {label}
          </SidebarLink>)}
      </>
}, {
  header: <SidebarLink>
        {lifestyleLinksData.label}
      </SidebarLink>,
  body: <>
        {lifestyleLinksData.subRoutes.map(({
      key,
      url,
      label
    }) => <SidebarLink key={key} href={helper.attachQueryStringToRoute({
      url
    }).url} ml="20px">
            {label}
          </SidebarLink>)}
      </>
}, {
  header: <SidebarLink href={helper.attachQueryStringToRoute({
    url: dogVideosData.url
  }).url}>
        {dogVideosData.label}
      </SidebarLink>
}, {
  header: <SidebarLink>
        {wagServicesData.label}
      </SidebarLink>,
  body: <>
        {wagServicesData.subRoutes.map(({
      key,
      url,
      label
    }) => <SidebarLink key={key} href={helper.attachQueryStringToRoute({
      url
    }).url} ml="20px">
            {label}
          </SidebarLink>)}
      </>
}];
const headerRightRoutes = [{
  ...dealsPillLinkData,
  screenTypes: [factory.SCREEN_TYPE.DESKTOP, factory.SCREEN_TYPE.IPAD],
  navigationItemProps: {
    backgroundColor: theme.colors.buttermilk,
    px: '13px',
    py: '2px',
    borderRadius: '30px',
    linkProps: {
      color: theme.colors.shingleFawn,
      whiteSpace: 'nowrap'
    }
  },
  animateNavigationItemBorderProps: {
    display: 'none'
  }
}, {
  ...funLinksData,
  rightIcon: <ChevronDownIconV2 width="10px" mt="3px" />,
  screenTypes: [factory.SCREEN_TYPE.DESKTOP, factory.SCREEN_TYPE.IPAD],
  DropdownComponent: NavigationDropdownList
}, {
  ...knowledgeLinksData,
  rightIcon: <ChevronDownIconV2 color="charcoal" width="10px" mt="3px" />,
  screenTypes: [factory.SCREEN_TYPE.DESKTOP, factory.SCREEN_TYPE.IPAD],
  DropdownComponent: NavigationDropdownList
}, {
  ...lifestyleLinksData,
  rightIcon: <ChevronDownIconV2 color="charcoal" width="10px" mt="3px" />,
  screenTypes: [factory.SCREEN_TYPE.DESKTOP, factory.SCREEN_TYPE.IPAD],
  DropdownComponent: NavigationDropdownList
}, {
  ...dogVideosData,
  screenTypes: [factory.SCREEN_TYPE.DESKTOP, factory.SCREEN_TYPE.IPAD]
}, {
  ...wagServicesData,
  rightIcon: <ChevronDownIconV2 color="charcoal" width="10px" mt="3px" />,
  screenTypes: [factory.SCREEN_TYPE.DESKTOP, factory.SCREEN_TYPE.IPAD],
  DropdownComponent: NavigationDropdownList
}];
export const DailyWagSiteNavigation = () => {
  const headerProps = {
    leftRoutes: [],
    rightRoutes: headerRightRoutes,
    IconSectionComponent: DailyWagLogoSection
  };
  return <SiteNavigation topNavigationProps={{
    mr: '100px'
  }} leftSidebarProps={{
    routes: sidebarRoutes
  }} headerProps={{
    ...headerProps
  }} data-sentry-element="SiteNavigation" data-sentry-component="DailyWagSiteNavigation" data-sentry-source-file="index.tsx" />;
};